'use strict';

import BaseService from './base.service';

class BankTxesService extends BaseService {
    /* @ngInject */
    constructor(BankTx, SegaUser) {
        super(BankTx, SegaUser);
    }

    fromStatement(opts = {
        date: null,
        comments: '',
        externalId: '',
        amount: 0
    }) {
        if (!opts.externalId) {
            return Promise.reject();
        }
        return this.Model.findOne({
            filter: {
                where: {
                    externalId: opts.externalId
                }
            }
        }).$promise.then(bankTx => {
            console.debug(bankTx);
            if (bankTx) {
                // already exists
                return true;
            } else {
                return false;
            }
        }, err => {
            console.debug(err);
            return false;
        }).then(exists => {
            if (!exists) {
                return this.Model.create({
                    date: opts.date,
                    amount: opts.amount,
                    externalId: opts.externalId,
                    metadata: {
                        comments: opts.comments
                    }
                }).$promise;
            } else {
                return Promise.reject();
            }
        });
    }
}

export default BankTxesService;
